import { InsertAppointment as UseCaseReduxInsertAppointment } from '~/domain/usecases/appointment/redux';
import { ReduxInsertAppointment } from '~/data/store/reducer/appointment/usecases/ReduxInsertAppointment';

/**
 * send request via REDUX.
 */
export const makeReduxInsertAppointment = (): UseCaseReduxInsertAppointment =>
  new ReduxInsertAppointment();
